import { render, staticRenderFns } from "./EditarEstados.vue?vue&type=template&id=3366c012&scoped=true"
import script from "./EditarEstados.vue?vue&type=script&lang=js"
export * from "./EditarEstados.vue?vue&type=script&lang=js"
import style0 from "./EditarEstados.vue?vue&type=style&index=0&id=3366c012&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3366c012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3366c012')) {
      api.createRecord('3366c012', component.options)
    } else {
      api.reload('3366c012', component.options)
    }
    module.hot.accept("./EditarEstados.vue?vue&type=template&id=3366c012&scoped=true", function () {
      api.rerender('3366c012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/EditarEstados.vue"
export default component.exports